import React from 'react';
import LinearProgress from '@material-ui/core/LinearProgress';
import './style.scss';
import { useAppSelector } from 'careand-redux/store';
import { CircularProgress } from '@material-ui/core';

const LoadingDataSpinner = (props) => {
  const loadingData = useAppSelector((state) => state.ui.loadingData);

  if (loadingData <= 0) {
    return null;
  }

  return (
    <div className="loading-data-spinner animated fadeInDown" id="global-loading-bar">
      <LinearProgress
        variant="query"
        className="linear-progress"
        classes={{ barColorPrimary: 'primary-bar-color' }}
      />
    </div>
  );
};

/**
 * @param {any} Props
 */
export const CustomLoadingDataSpinner = ({ loading, color, style }) => {
  return (
    loading && (
      <CircularProgress
        variant="indeterminate"
        classes={{ colorPrimary: color ?? '#FF0000', colorSecondary: color ?? '#FF0000' }}
        style={style}
      />
    )
  );
};

export default LoadingDataSpinner;
